export const commentsByCourse = {
  comments: {
    items: [
      {
        id: 4707,
        content: "qwe",
        image_url: null,
        thumbnail_url: null,
        parent_id: null,
        time_elapsed: "22/11/2022",
        creator: {
          id: 10338,
          name: "Mitchell Vu",
          avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
          description: null,
          username: "mitchellvu",
          dob: "2022-10-31 00:00:00",
          phone: "0915825534",
          gender: "1",
          email: "mitchell.vu0208@gmail.com",
          isTeacher: true,
        },
        permission: {
          update: true,
          delete: true,
          featured: true,
        },
        lesson: {
          id: 1836,
          model_id: 1840,
          name: "Thực hành mẫu: Hướng dẫn bài tập thực hành số 19",
          description:
            '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Hướng dẫn thiết kế chi tiết về 1 Poster về chủ đề âm nhạc</p>',
          thumbnail_url:
            "https://i.vimeocdn.com/video/1404117998-7900ef71414ab30dcfc1e49b40b78688a93a4bb5a16170bab8508a03395818a1-d_200x150?r=pad",
          properties: null,
          pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
          lesson_type: "video",
          status: "private",
          order: 19,
          duration: 436,
        },
        childComments: [],
        reacts: [
          {
            id: 197,
            type: "like",
            status: "active",
            creator: {
              id: 10338,
              name: "Mitchell Vu",
              avatar_url:
                "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
              description: null,
              username: "mitchellvu",
              dob: "2022-10-31 00:00:00",
              phone: "0915825534",
              gender: "1",
              email: "mitchell.vu0208@gmail.com",
            },
          },
        ],
        reaction: {
          id: 197,
          type: "like",
          status: "active",
        },
      },
      {
        id: 4695,
        content: "Em nộp bài kết thúc môn ạ",
        image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665717729ftMRON2pAsEfheZ.jpg",
        thumbnail_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665717729CkJzEDscMz7NZuJ.jpg",
        parent_id: null,
        time_elapsed: "14/10/2022",
        creator: {
          id: 10370,
          name: "Mai Thị Thanh Diễm",
          avatar_url:
            "https://lh3.googleusercontent.com/a-/AOh14GhGkiDGcb2mZcrb90CAPGCmfetz_r5ic_Kkrgw0=s96-c",
          description: null,
          username: "maithanhdiem312@gmail.com",
          dob: null,
          phone: "0339216779",
          gender: "2",
          email: "maithanhdiem312@gmail.com",
          isTeacher: false,
        },
        permission: {
          update: true,
          delete: true,
          featured: true,
        },
        lesson: {
          id: 1835,
          model_id: 1839,
          name: "Bài tập thực hành số 19: Thiết kế Poster hoàn chỉnh cho Bộ phim/Bài hát/Sự kiện bạn thích",
          description:
            '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Đây là 1 bài tập cần kết hợp tất cả các công cụ đã học từ buổi 1 đến bây giờ: công cụ tạo hình, viết chữ, thao tác với màu sắc, hình ảnh và tạo hiệu ứng.<br /> </p>',
          thumbnail_url:
            "https://i.vimeocdn.com/video/1404118580-c5f98fffbe0e0f61af4897d53cec0a277adfe6dcae3d055baad070f9b34f918b-d_200x150?r=pad",
          properties: null,
          pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
          lesson_type: "video",
          status: "private",
          order: 18,
          duration: 44,
        },
        childComments: [
          {
            id: 4696,
            content:
              "Phần bài tập của em nhìn chung đã đủ yêu cầu về công cụ rồi nha. Anh góp ý thêm một xíu tại những phần ứng dụng Clipping Mask để cắt ảnh thì mình có thể cắt vào trong phần hình một chút để tránh có những đoạn cắt nhìn bị lộ nhé. Bên cạnh đó tham khảo thêm nhiều style khác đã được để cập trong khoá học nha.",
            image_url: null,
            thumbnail_url: null,
            parent_id: 4695,
            time_elapsed: "14/10/2022",
            creator: {
              id: 488,
              name: "Nguyễn Huy Minh",
              avatar_url:
                "https://d1j8r0kxyu9tj8.cloudfront.net/images/1572823129U6lHE7c4YcPdCQB.jpg",
              description: null,
              username: "huyminh003@gmail.com",
              dob: null,
              phone: "0392862086",
              gender: null,
              email: "huyminh003@gmail.com",
              isTeacher: true,
            },
            permission: {
              update: true,
              delete: true,
              featured: true,
            },
            lesson: {
              id: 1709,
              model_id: 1713,
              name: "Cắt ghép Vector",
              description:
                '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Nội dung bài giảng đi sâu chi tiết về công cụ Shape Modes và Pathfinders</p>',
              thumbnail_url:
                "https://i.vimeocdn.com/video/1404076191-7599826bcccb720a62cbf7ccbb6ca3907d160c98205c6918f133ad8c8915a3cf-d_200x150?r=pad",
              properties: null,
              pinterest_url:
                "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
              lesson_type: "video",
              status: "private",
              order: 17,
              duration: 23,
            },
          },
        ],
        featured: {
          id: 193,
          type: "featured",
          status: "active",
          creator: {
            id: 10,
            name: "Nguyễn Hùng",
            avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/images/1569687953OwEYNJf6eP3PhOT.jpg",
            description: null,
            username: "hungnm315.ftu",
            dob: null,
            phone: "0912469615",
            gender: "1",
            email: "hungnm315.ftu@gmail.com",
          },
          permission: {
            update: true,
          },
        },
        reacts: [],
      },
      {
        id: 4693,
        content: null,
        image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665651081e6S21oi8iFAHvEF.jpg",
        thumbnail_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665651080UnuSQviSSMR10SS.jpg",
        parent_id: null,
        time_elapsed: "13/10/2022",
        creator: {
          id: 10370,
          name: "Mai Thị Thanh Diễm",
          avatar_url:
            "https://lh3.googleusercontent.com/a-/AOh14GhGkiDGcb2mZcrb90CAPGCmfetz_r5ic_Kkrgw0=s96-c",
          description: null,
          username: "maithanhdiem312@gmail.com",
          dob: null,
          phone: "0339216779",
          gender: "2",
          email: "maithanhdiem312@gmail.com",
          isTeacher: false,
        },
        permission: {
          update: true,
          delete: true,
          featured: true,
        },
        lesson: {
          id: 1816,
          model_id: 1820,
          name: "Bài tập thực hành số 16: Thiết kế ảnh theo phong cách Zeka Design",
          description:
            '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Bài tập kết thúc chương thao tác với ảnh: Sử dụng các thao tác xử lý ảnh đã học để thiết kế 1 ảnh bìa tạp chí theo phong cách Zeka Design</p>',
          thumbnail_url:
            "https://i.vimeocdn.com/video/1404115317-5063d1cc12167ab174c6cf1436dd8710f075d174f37dc038c7887ec95ddccffe-d_200x150?r=pad",
          properties: null,
          pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
          lesson_type: "video",
          status: "private",
          order: 14,
          duration: 24,
        },
        childComments: [],
        reacts: [],
      },
      {
        id: 4690,
        content: null,
        image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665578563TghLYfTPCNdHEMB.png",
        thumbnail_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665578563nmD6JL7DXPIHznA.png",
        parent_id: null,
        time_elapsed: "12/10/2022",
        creator: {
          id: 10370,
          name: "Mai Thị Thanh Diễm",
          avatar_url:
            "https://lh3.googleusercontent.com/a-/AOh14GhGkiDGcb2mZcrb90CAPGCmfetz_r5ic_Kkrgw0=s96-c",
          description: null,
          username: "maithanhdiem312@gmail.com",
          dob: null,
          phone: "0339216779",
          gender: "2",
          email: "maithanhdiem312@gmail.com",
          isTeacher: false,
        },
        permission: {
          update: true,
          delete: true,
          featured: true,
        },
        lesson: {
          id: 1795,
          model_id: 1799,
          name: "Công cụ Create Outlines và Bài tập thực hành số 11: tạo hiệu ứng chữ lồng",
          description:
            '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Nội dung trong bài giảng gồm:<br />- Định nghĩa Typeface và Font<br />- Phân loại Typeface<br />- Create Outlines<br />- Bài tập về Create Outlines: Áp dụng việc Create Outlines chữ với bảng Pathfinder để tạo ra chữ dạng Interlaced Text (chữ lồng chữ)</p>',
          thumbnail_url:
            "https://i.vimeocdn.com/video/1404113052-73d9c71cf1f5e50101c1cded2734272a55f5987989fbeb13d9385246cf022ed3-d_200x150?r=pad",
          properties: null,
          pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
          lesson_type: "video",
          status: "private",
          order: 4,
          duration: 213,
        },
        childComments: [],
        reacts: [],
      },
      {
        id: 4683,
        content: null,
        image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665305049N262757FpYH4HAc.jpg",
        thumbnail_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1665305048RwaAEpFzzfqrTMq.jpg",
        parent_id: null,
        time_elapsed: "9/10/2022",
        creator: {
          id: 10370,
          name: "Mai Thị Thanh Diễm",
          avatar_url:
            "https://lh3.googleusercontent.com/a-/AOh14GhGkiDGcb2mZcrb90CAPGCmfetz_r5ic_Kkrgw0=s96-c",
          description: null,
          username: "maithanhdiem312@gmail.com",
          dob: null,
          phone: "0339216779",
          gender: "2",
          email: "maithanhdiem312@gmail.com",
          isTeacher: false,
        },
        permission: {
          update: true,
          delete: true,
          featured: true,
        },
        lesson: {
          id: 1791,
          model_id: 1795,
          name: "Thực hành mẫu: Hướng dẫn bài tập thực hành 10",
          description:
            '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Hướng dẫn cách áp dụng Gradient để vẽ theo style Gradient Galaxy</p><p>&nbsp;</p><p>Phím tắt lưu ý:</p><p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Ctrl C, Ctrl F: Dán đổi tượng lên trên đối tượng đang chọn<br />Pencil tool (N): Cắt hình<br />Bảng Pathfinder: Tách hình</p>',
          thumbnail_url:
            "https://i.vimeocdn.com/video/1404112510-aa21dca9d59371de1009629a755d94423fd881d1743ea56dce956e64e03430ab-d_200x150?r=pad",
          properties: null,
          pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
          lesson_type: "video",
          status: "private",
          order: 14,
          duration: 265,
        },
        childComments: [],
        featured: {
          id: 192,
          type: "featured",
          status: "active",
          creator: {
            id: 10,
            name: "Nguyễn Hùng",
            avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/images/1569687953OwEYNJf6eP3PhOT.jpg",
            description: null,
            username: "hungnm315.ftu",
            dob: null,
            phone: "0912469615",
            gender: "1",
            email: "hungnm315.ftu@gmail.com",
          },
          permission: {
            update: true,
          },
        },
        reacts: [],
      },
    ],
    meta: {
      total: 28,
      count: 5,
      per_page: 5,
      current_page: 1,
      total_pages: 6,
      links: {
        next: "http://localhost:6868/api/auth-web/comment/by-course/123?page=2",
      },
    },
  },
  status: 1,
};

export const createComment = (params, body) => ({
  comment: {
    id: Math.floor(Math.random() * 200) + 1,
    content: body.content_comment,
    image_url: body.image_url,
    thumbnail_url: body.thumbnail_url,
    parent_id: body.parent_id ?? null,
    time_elapsed: "Vừa xong",
    creator: {
      id: 10338,
      name: "Mitchell Vu",
      avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
      description: null,
      username: "mitchellvu",
      dob: "2022-10-31 00:00:00",
      phone: "0915825534",
      gender: "1",
      email: "mitchell.vu0208@gmail.com",
      isTeacher: true,
    },
    permission: {
      update: true,
      delete: true,
      featured: true,
    },
    lesson: {
      id: 1715,
      name: "Giới thiệu chương 2",
      description:
        '<p><style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}--></style>Nội dung chương 2 gồm:<br />Cắt ghép Vector<br />Cắt ghép<br />Vector<br />Stroke<br />Nhóm công<br />cụ Modify</p>',
      thumbnail_url:
        "https://i.vimeocdn.com/video/1404076005-dded8129bfa6030796a3767cf7a123ecc694fcdf7c23374abd2a2e5d763c95fb-d_200x150?r=pad",
      properties: null,
      pinterest_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1648109786bshStCY5A2JGoJS.jpg",
      status: "private",
      order: 1,
      duration: 12,
    },
    childComments: [],
  },
  status: 1,
});

export const featureComment = (params, body) => ({
  featured: {
    id: 196,
    type: "featured",
    status: body.status,
    creator: {
      id: 10338,
      name: "Mitchell Vu",
      avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
      description: null,
      username: "mitchellvu",
      dob: "2022-10-31 00:00:00",
      phone: "0915825534",
      gender: "1",
      email: "mitchell.vu0208@gmail.com",
    },
    permission: {
      update: true,
    },
  },
  status: 1,
});

export const reactComment = (params, body) => ({
  reaction: {
    id: 300,
    type: body.type,
    status: "active",
  },
  reacts: [
    {
      id: 197,
      type: "like",
      status: "active",
      creator: {
        id: 10338,
        name: "Mitchell Vu",
        avatar_url:
          "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
        description: null,
        username: "mitchellvu",
        dob: "2022-10-31 00:00:00",
        phone: "0915825534",
        gender: "1",
        email: "mitchell.vu0208@gmail.com",
      },
    },
    {
      id: 198,
      type: "love",
      status: "active",
      creator: {
        id: 10338,
        name: "Mitchell Vu",
        avatar_url:
          "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
        description: null,
        username: "mitchellvu",
        dob: "2022-10-31 00:00:00",
        phone: "0915825534",
        gender: "1",
        email: "mitchell.vu0208@gmail.com",
      },
    },
  ],
  status: 1,
});

export const listReactions = (params) => ({
  reactions: [
    {
      id: 196,
      type: "like",
      status: "active",
      creator: {
        id: 10338,
        name: "Mitchell Vu",
        avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
        description: null,
        username: "mitchellvu",
        dob: "2022-10-31 00:00:00",
        phone: "0915825534",
        gender: "1",
        email: "mitchell.vu0208@gmail.com",
      },
    },
    {
      id: 197,
      type: "love",
      status: "active",
      creator: {
        id: 10338,
        name: "Mitchell Vu",
        avatar_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/16523752512Y4apy6YuHp9gcA.jpg",
        description: null,
        username: "mitchellvu",
        dob: "2022-10-31 00:00:00",
        phone: "0915825534",
        gender: "1",
        email: "mitchell.vu0208@gmail.com",
      },
    },
  ],
  status: 1,
});
